module.exports = __webpack_public_path__ + "assets/img/4239350af4b34a233fd5e68e62a6d11f.svg";